export const getMidnightSeconds = (seconds: number) => {
  const secondsFromMidnight = seconds % 86400; // seconds to Today, 00:00
  const midnightSeconds = seconds - secondsFromMidnight;
  return midnightSeconds;
};
